export default function ({ next, store, nextMiddleware }) {
  if (!store.getters.isUserVerifiedOrSubscribed) {
    return next({ name: "email_verify", replace: true });
  }

  return nextMiddleware();
}
